/**
 * Route definitions for the dashboard users section (user list,
 * user detail, create/edit, and filter drawer).
 * Mirrors the pattern in views/admin/billing/routes.tsx.
 */
import { RouteObject } from "react-router-dom";
import { featureFlags } from "../../../featureFlags";
import { withHandle } from "../../../utils/route.util";
import { DashboardUserCreateView } from "./DashboardUserCreateView";
import { DashboardUserEditView } from "./DashboardUserEditView";
import { DashboardUsersView } from "./DashboardUsersView";
import { DashboardUserView } from "./DashboardUserView";
import { DashboardUsersFilterInner, path as dashboardUsersFilterPath } from "./DashboardUsersFilter";

export const dashboardUsersFilterRoute: RouteObject = {
  path: dashboardUsersFilterPath,
  element: <DashboardUsersFilterInner />,
};

export const dashboardUsersRoutes: RouteObject[] = [
  {
    path: "dashboard-users",
    element: <DashboardUsersView />,
    ...withHandle("admin-dashboard-users"),
    children: [
      ...(featureFlags.newSearchExperience ? [dashboardUsersFilterRoute] : []),
      {
        path: "create",
        element: <DashboardUserCreateView />,
        ...withHandle("admin-dashboard-user-create"),
      },
      {
        path: ":id",
        element: <DashboardUserView />,
        ...withHandle("admin-dashboard-user-detail"),
      },
      {
        path: ":id/edit",
        element: <DashboardUserEditView />,
        ...withHandle("admin-dashboard-user-edit"),
      },
    ],
  },
];
